module.exports = __webpack_public_path__ + "img/mail.6aa1c140.svg";